import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { REGIONS } from "@/lib/locations";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const ChineseLocationsPage = () => {
  return (
    <div className="flex min-h-screen flex-col" lang="zh">
      <SEO 
        title="服务区域 | Uplevel Cleaning"
        description="我们服务于萨克拉门托、洛杉矶、旧金山湾区、圣地亚哥和奥兰治县。查找您的城市！"
        keywords="服务区域, 加州清洁服务"
        url="https://uplevelcleaning.com/zh/locations"
        alternateUrl="https://uplevelcleaning.com/locations"
        alternateLang="en-US"
        lang="zh"
      />
      <Navbar />
      <main className="flex-1 pt-32 pb-24 bg-muted/10">
        <div className="container max-w-6xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">我们的服务区域</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              我们在加州各地提供顶级的房屋清洁服务。请在下方选择您的地区。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Object.entries(REGIONS).map(([regionSlug, region]) => (
              <div key={regionSlug} className="bg-background rounded-2xl border shadow-sm overflow-hidden flex flex-col">
                <div className="bg-primary/10 p-6 border-b">
                  <h2 className="text-2xl font-bold text-primary flex items-center gap-2">
                    <MapPin className="h-6 w-6" /> {region.name}
                  </h2>
                </div>
                <div className="p-6 flex-1">
                  <ul className="grid grid-cols-2 gap-3 mb-8">
                    {region.cities.map(city => (
                      <li key={city}>
                        <Link 
                          to={`/zh/${city.toLowerCase().replace(/\s+/g, '-')}`}
                          className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-1"
                        >
                          <ArrowRight className="h-3 w-3" /> {city}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="p-6 pt-0 mt-auto">
                  <Button asChild className="w-full" variant="outline">
                    <Link to={`/zh/${region.cities[0].toLowerCase().replace(/\s+/g, '-')}`}>
                      {region.name}服务
                    </Link>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ChineseLocationsPage;
